export default __webpack_public_path__ + "static/media/lu.067be87a.jpg";